import Wrapper from '../../../components/wrapper';
import Container from '../../../containers';
import { TyTableTitle } from '@tymbe/ty-components/table';
import { TyNavTabs, TyNavLink } from '@tymbe/ty-components/navigation';
import { Outlet, useNavigate } from 'react-router-dom';
import { Form } from 'informed';
import { TySearchBox } from '@tymbe/ty-components/inputs';
import { SecondaryButton } from '@tymbe/ui-primitives';
import { useQuery } from 'react-query';
import feathersClient from '../../../apiClient';
import { VodafoneTariffState } from '@tymbe/schema/enums';
import { PaginatedTotalIndicator } from '../../../components/BadgePills/PaginatedTotalIndicator';

const paidAmountId = 'admin/vodafoneTariff/paidAmount';
const requestedTransferAmountId = 'admin/vodafoneTariff/requestedTransferAmount';
const overduePaymentsAmountId = 'admin/vodafoneTariff/overduePaymentsAmount';
const activeAmountId = 'admin/vodafoneTariff/activeAmount';

const AdminAdministrationVodafoneTariffPage = () => {
  const pageTitle = 'Vodafone Tarify';
  const navigate = useNavigate();

  const { data: paidAmount } = useQuery(
    [paidAmountId],
    () =>
      feathersClient.service('vodafone-tariff').find({
        query: {
          state: VodafoneTariffState.PAYMENT_SUCCESS,
          $limit: 0,
        },
      })
  );

  const { data: requestedTransferAmount } = useQuery(
    [requestedTransferAmountId],
    () =>
      feathersClient.service('vodafone-tariff').find({
        query: {
          state: VodafoneTariffState.REQUESTED_TRANSFER,
          $limit: 0,
        },
      })
  );

  const { data: overduePaymentsAmount } = useQuery(
    [overduePaymentsAmountId],
    () =>
      feathersClient.service('vodafone-tariff').find({
        query: {
          $modify: ['withPendingPayments'],
          $limit: 0,
        },
      })
  );

  const { data: activeAmount } = useQuery(
    [activeAmountId],
    () =>
      feathersClient.service('vodafone-tariff').find({
        query: {
          state: VodafoneTariffState.ACTIVE,
          $limit: 0,
        },
      })
  );


  return (
    <Wrapper padding="0px" margin="0px">
      <Container
        iconcolor="#B3CA1F"
        background="#fff"
        elevate
        contentstyle={{
          paddingLeft: '190px',
          paddingTop: '24px',
          paddingRight: '24px',
          paddingBottom: '24px',
        }}
        desktopHeader
        sidebar
        sidebarExtra
      >
        <TyTableTitle className="flex justify-between">
          <div className="flex items-center gap-4">
            {pageTitle}
            <SecondaryButton
              onClick={() => navigate('/administration/vodafone-imports')}
            >
              Spravovat vyúčtování
            </SecondaryButton>
            <SecondaryButton
              onClick={() => window.open('https://ty-bi.tytodas.cz/collection/103-vodafone-tarify', '_blank')}
            >
              Metabase přehledy
            </SecondaryButton>
          </div>
          <Form onSubmit={() => { /* Empty form handler */ }}>
            <TySearchBox
              name="search"
              placeholder="Hledej dle jména, telefonu, email, person_id nebo fakturoid ID"
            />
          </Form>
        </TyTableTitle>
        <TyNavTabs>
          <TyNavLink key="paid" to={{ pathname: 'paid' }}>
            Zaplacené žádosti
            <PaginatedTotalIndicator data={paidAmount} />
          </TyNavLink>
          <TyNavLink key="requested-transfer" to={{ pathname: 'requested-transfer' }}>
            Předáno k aktivaci
            <PaginatedTotalIndicator data={requestedTransferAmount} />
          </TyNavLink>
          <TyNavLink key="overdue-payments" to={{ pathname: 'overdue-payments' }}>
            Nezaplacené vyúčtování
            <PaginatedTotalIndicator data={overduePaymentsAmount} />
          </TyNavLink>
          <TyNavLink key="active" to={{ pathname: 'active' }}>
            Aktivní
            <PaginatedTotalIndicator data={activeAmount} />
          </TyNavLink>
          <TyNavLink key="cancelled" to={{ pathname: 'cancelled' }}>
            Zrušeno
          </TyNavLink>
          <TyNavLink key="deactivated" to={{ pathname: 'deactivated' }}>
            Deaktivováno (neplatiči)
          </TyNavLink>
          <TyNavLink key="payment-pending" to={{ pathname: 'payment-pending' }}>
            Čeká na platbu
          </TyNavLink>
        </TyNavTabs>
        <Outlet />
      </Container>
    </Wrapper>
  );
};

export default AdminAdministrationVodafoneTariffPage;
